// extracted by mini-css-extract-plugin
export var logo = "_cg-2";
export var logoWrapper = "_cg-1";
export var strip = "_cg-0";